import { call, put, select } from 'redux-saga/effects';

import {
  createDeviceLabelRequest,
  createLabelRequest,
  deleteDeviceLabelRequest,
  deleteLabelRequest,
  updateLabelRequest,
} from '../requests';
import { pathSelector } from '../../../selectors';
import {
  addLabelToSiteFilter,
  addLabelToDevice,
  createLabel,
  deleteLabel,
  removeLabelFromSiteFilter,
  removeLabelFromDevice,
  updateLabel,
} from '../../../actions';
import { createLocalId } from '../../../utils/local-id';

export function* createLabelService(siteId, data) {
  const localId = yield call(createLocalId);

  yield put(
    createLabel({
      ...data,
      siteId,
      id: localId,
    }),
  );

  yield call(createLabelRequest, siteId, localId, data);
}

export function* createLabelInCurrentSiteService(data) {
  const { siteId } = yield select(pathSelector);

  yield call(createLabelService, siteId, data);
}

export function* updateLabelService(id, data) {
  yield put(updateLabel(id, data));
  yield call(updateLabelRequest, id, data);
}

export function* deleteLabelService(id) {
  yield put(deleteLabel(id));
  yield call(deleteLabelRequest, id);
}

export function* addLabelToDeviceService(id, deviceId) {
  yield put(addLabelToDevice(id, deviceId));
  yield call(createDeviceLabelRequest, deviceId, id);
}

export function* addLabelToCurrentDeviceService(id) {
  const { deviceId } = yield select(pathSelector);

  yield call(addLabelToDeviceService, id, deviceId);
}

export function* removeLabelFromDeviceService(id, deviceId) {
  yield put(removeLabelFromDevice(id, deviceId));
  yield call(deleteDeviceLabelRequest, deviceId, id);
}

export function* removeLabelFromCurrentDeviceService(id) {
  const { deviceId } = yield select(pathSelector);

  yield call(removeLabelFromDeviceService, id, deviceId);
}

export function* addLabelToSiteFilterService(id, siteId) {
  yield put(addLabelToSiteFilter(id, siteId));
}

export function* addLabelToFilterInCurrentSiteService(id) {
  const { siteId } = yield select(pathSelector);

  yield call(addLabelToSiteFilterService, id, siteId);
}

export function* removeLabelFromSiteFilterService(id, siteId) {
  yield put(removeLabelFromSiteFilter(id, siteId));
}

export function* removeLabelFromFilterInCurrentSiteService(id) {
  const { siteId } = yield select(pathSelector);

  yield call(removeLabelFromSiteFilterService, id, siteId);
}
